import React, { MouseEvent } from 'react';
import { ITokenizedCard } from '../../../../../payment/domain/models';
import { SelectCardHeader } from './SelectCardHeader';
import { SelectCardOptions } from './SelectCardOptions';

interface ISelectCardProps {
	cards: ITokenizedCard[];
	onClickAddNewCard: (e: MouseEvent) => void;
}

const MAX_CARDS = 3;

export const SelectCard = ({ cards, onClickAddNewCard }: ISelectCardProps) => {
	const canAddNewCard = cards.length < MAX_CARDS;

	return (
		<>
			<SelectCardHeader
				canAddNewCard={canAddNewCard}
				onClickAddNewCard={onClickAddNewCard}
			/>
			<SelectCardOptions cards={cards} />
		</>
	);
};
